import { render, staticRenderFns } from "./SelProduct.vue?vue&type=template&id=13ac7215&scoped=true"
import script from "./SelProduct.vue?vue&type=script&lang=js"
export * from "./SelProduct.vue?vue&type=script&lang=js"
import style0 from "./SelProduct.vue?vue&type=style&index=0&id=13ac7215&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac7215",
  null
  
)

export default component.exports